import axios from '../../utils/axios';
import apiRequest from './apiRequest';

const buildBlogListQuery = ({
  page, limit, searchValue, clusterId, published, featured, sort,
}) => {
  const params = new URLSearchParams({ page, limit, searchValue });
  if (clusterId) params.set('clusterId', clusterId);
  if (published !== undefined && published !== '') params.set('published', published);
  if (featured !== undefined && featured !== '') params.set('featured', featured);
  if (sort) params.set('sort', sort);
  return params.toString();
};

const getBlogs = ({
  page, limit, searchValue, clusterId, published, featured, sort,
}) => apiRequest(() => axios.get(`/api/blog?${buildBlogListQuery({
  page, limit, searchValue, clusterId, published, featured, sort,
})}`));

const getBlog = ({ id }) => apiRequest(() => axios.get(`/api/blog/${id}`));

const postBlogCreate = ({ blog }) => apiRequest(() => axios.post('/api/blog/create', blog));

const putBlogEdit = ({ id, blog }) => apiRequest(() => axios.put(`/api/blog/${id}`, blog));

const postBlogPublish = ({ blogs }) => apiRequest(() => axios.post('/api/blog/publish', blogs));

export default {
  getBlogs,
  getBlog,
  postBlogCreate,
  putBlogEdit,
  postBlogPublish,
};
